import { useContext, useMemo } from 'react'
import ImageKit from 'imagekit-javascript'
import { UserContext } from '../providers'

const useImageKitClient = (): ImageKit => {
  const { user } = useContext(UserContext)

  const imagekit = useMemo(() => {
    if (user) {
      return new ImageKit({
        urlEndpoint: user.baseUrlForClientImageFetch,
        publicKey: user.publicKey,
        authenticationEndpoint: `/api/clients/${user.clientNumber}/upload/signature/v2`,
        apiVersion: 'v2-alpha',
      })
    }

    return new ImageKit({ urlEndpoint: 'https://ik.imagekit.io/demo' })
  }, [user?.baseUrlForClientImageFetch])

  return imagekit
}

export default useImageKitClient
